module.exports = __webpack_public_path__ + "img/pgd_a_00110.1e4ec372.png";